export const getNewButton = (item, forceInversed, forceCustom, theme) => {
  const variantToMigrate = forceInversed
    ? 'inversed'
    : item.attributes.variant || 'primary';
  const themeColors = theme.colors;
  const themeButton = theme.buttons[variantToMigrate];

  return {
    ...item,
    attributes: {
      ...item.attributes,
      borderColor: forceCustom ? item.attributes.borderColor : null,
      borderWidth: forceCustom ? item.attributes.borderWidth : null,
      buttonBackgroundColor: forceCustom
        ? item.attributes.buttonBackgroundColor || themeColors[themeButton.bg]
        : null,
      buttonFontFamily: forceCustom ? item.attributes.buttonFontFamily : null,
      builderFontSize: forceCustom
        ? item.attributes.builderFontSize || '14px'
        : null,
      builderLetterSpacing: forceCustom
        ? item.attributes.builderLetterSpacing || 0
        : null,
      buttonPadding: forceCustom
        ? item.attributes.buttonPadding || '7px 12px'
        : null,
      buttonRadius: forceCustom
        ? item.attributes.buttonRadius ||
          theme.themeVariables.buttonBorderRadius
        : null,
      buttonColor: forceCustom
        ? item.attributes.buttonColor || themeColors[themeButton.color]
        : null,
      hasBorder: forceCustom ? item.attributes.hasBorder : null,
      mode: forceCustom ? 'custom' : 'network',
      variant:
        forceCustom || !forceInversed
          ? item.attributes.variant || 'primary'
          : 'inversed',
    },
  };
};
